import { InputAdornment } from "@material-ui/core";
import { useField } from "formik";
import * as Yup from "yup";
import { AttributeIdentifiers } from "../../../../../libs/graphql-schema/src/models";
import { ControlState } from "../models/flexible/control-state";
import { combinePaths } from "../models/flexible/utils";
import { PriceType } from "../models/generated/graphql";
import { getPathPrefix } from "../utils/get-path-prefix";
import { isEmptyValue } from "../utils/is-empty-value";
import { renderRequiredMessage } from "../utils/render-required-message";
import { GeneralFieldController } from "./general-field-controller";

export class DiscountRateFieldController extends GeneralFieldController {
	override createValidationRule(_initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return Yup.number()
			.nullable()
			.test("is-valid-rate", translation("between-0-and-100"), (rate?: any) => isEmptyValue(rate) || (rate >= 0 && rate <= 100))
			.when(AttributeIdentifiers.BasePrice, (basePrice, schema) =>
				basePrice === PriceType.CustomPricePercent ||
				basePrice === PriceType.PublicPricePercent ||
				basePrice === PriceType.ExFactoryPricePercent
					? schema.required(renderRequiredMessage(this.schema.attribute.identifier, translation))
					: schema
			);
	}

	override useControlProps(_path: string) {
		return {
			InputProps: { endAdornment: <InputAdornment position="end">%</InputAdornment> },
		};
	}

	override useControlState(path: string): ControlState {
		const [{ value: basePrice }] = useField<PriceType>(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.BasePrice));
		return basePrice === PriceType.CustomPricePercent ||
			basePrice === PriceType.PublicPricePercent ||
			basePrice === PriceType.ExFactoryPricePercent
			? "enabled"
			: "hidden";
	}
}
